import { createQueryKeys } from 'utils/react-query-utils';

export const employmentKeys = createQueryKeys('employments', (createKey) => ({
  default: createKey('employments'),
  single: (employmentId?: string) => createKey(employmentId),
  singleUser: (userId?: string) => createKey(userId),
  lspEmployments: (lspId?: string) => createKey(lspId),
}));
